import React from 'react';
import Layout from '../../components/Layout';
import Register from './Register';
import messages from '../../locale/messages';
import { getBatch2PageSeo } from '../../helpers/routeSeo';

export default async function action({ store, query }) {

    // From Redux Store
    let isAuthenticated = store.getState().runtime.isAuthenticated;
    let refer = query.refer;

    if (isAuthenticated) {
      return { redirect: '/' };
    }
    
    const { title } = getBatch2PageSeo(store, messages.batch2RegisterMetaTitle, null);
    return {
      title,
      description: '',
      robotsNoindex: true,
      component: <Layout><Register title={title} refer={refer} /></Layout>,
    };
  };
